export default {
  translation: {
    common: {
      emailOrUsername: 'Email nebo uživatelské jméno',
      invalidUsernameOrPassword: 'Nesprávné uživatelské jméno nebo heslo',
      logInToBoards: 'Přihlásit se',
      noInternetConnection: 'Bez připojení k internetu',
      pageNotFound_title: 'Stránka nenalezena',
      password: 'Heslo',
      serverConnectionFailed: 'Připojení k serveru selhalo',
      unknownError: 'Neznámá chyba, zkuste to později',
    },

    action: {
      logIn: 'Přihlásit se',
    },
  },
};
